export const isDev = __BLYCARE_DEV_MODE__;
export const isMock = __BLYCARE_MOCK_MODE__;
export const isLocal = __BLYCARE_LOCAL_MODE__;
export const apiBaseUrl = __BLYCARE_API_BASE_URL__;
